import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable, from, throwError } from "rxjs";
import { IndexdbService } from "./indexdb-service";
import { CryptoService } from "./crypto-service";

@Injectable({
  providedIn: "root",
})
export class EncryptService {
  username: string = "practicecrown@bizbrolly.com";
  password: string = "94ba69fdd6ac7c1576e4b079514aa04004822824";
  ipKey: string = "13123123123";
  key: any;

  constructor(
    private http: HttpClient,
    private cryptoService: CryptoService,
    private indexdbService: IndexdbService
  ) {}

  async DataEncryption(body: any): Promise<any> {

    try {

      // Wait for user data from IndexedDB
      const data: any = await this.indexdbService.getCryptoKeyFromLocalStorage();
      // const keys = data?.key;

      // if (!keys) throw new Error("No keys found");

      // const CPrivateKey: string = keys.CPrivateKey;
      // const spublicKey: string = keys.sPublicKey;
      // const AesKey: string = keys.AesKey;
      const keys = data?.split("|");
      if (!keys) throw new Error("No keys found");
      

      console.log("Fetched key:", keys);

      const CPrivateKey: string = keys[0];
      const spublicKey: string = keys[1];
      const AesKey: string = keys[2];

      // Decrypt AES key and import
      const aes = await this.cryptoService.decryptAesKeyWithRsa(
        this.cryptoService.base64ToUtf8(CPrivateKey),
        this.cryptoService.base64ToUtf8(AesKey)
      );

      this.key = await this.cryptoService.importAesKeyFromBase64(aes);

      // Encrypt the body
      const encBody = await this.cryptoService.encrypt(this.key, body,spublicKey);

      return { data: encBody }; // ✅ This now properly resolves the promise
    } catch (error) {
      console.error("Encryption failed:", error);
      throw error;
    }
  }



 async dataDecryption(response: any): Promise<any> {
    try {
      const data: any = await this.indexdbService.getCryptoKeyFromLocalStorage(); // Fetch keys from DB
      const keys = data?.split("|");
      if (!keys) throw new Error("No keys found");

      console.log("Fetched key:", keys);

      const CPrivateKey: string = keys[0];
      const spublicKey: string = keys[1];
      const AesKey: string = keys[2];

      // Decrypt AES key and import it
      const AekEnc = await this.cryptoService.decryptAesKeyWithRsa(
        this.cryptoService.base64ToUtf8(CPrivateKey),
        this.cryptoService.base64ToUtf8(AesKey)
      );

      const aesCrypto = await this.cryptoService.importAesKeyFromBase64(AekEnc);

      // Decrypt the response body
      const body = await this.cryptoService.decryptFromDotNet(response, aesCrypto,CPrivateKey);
      // Ensure the response is correctly parsed and returned
      return JSON.parse(body); // Decrypted response

    } catch (error) {
      console.error("Decryption failed:", error);
      throw error;
    }
  }

dataDecryptionObservable(response: any): Observable<any> {
    // Wrap the async decryption call into an observable
    return from(this.dataDecryption(response));  // Converts Promise to Observable
  }


}
